/* Jonathan Snook - MIT License - https://github.com/snookca/prepareTransition */
(function(a){a.fn.prepareTransition=function(){return this.each(function(){var b=a(this);b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd",function(){b.removeClass("is-transitioning")});var c=["transition-duration","-moz-transition-duration","-webkit-transition-duration","-o-transition-duration"];var d=0;a.each(c,function(a,c){d=parseFloat(b.css(c))||d});if(d!=0){b.addClass("is-transitioning");b[0].offsetWidth}})}})(jQuery);

/* replaceUrlParam - http://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery */
function replaceUrlParam(e,r,a){var n=new RegExp("("+r+"=).*?(&|$)"),c=e;return c=e.search(n)>=0?e.replace(n,"$1"+a+"$2"):c+(c.indexOf("?")>0?"&":"?")+r+"="+a};

/*============================================================================
  Money Format
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ((typeof Shopify) === 'undefined') { Shopify = {}; }
if (!Shopify.formatMoney) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

// Timber functions
window.timber = window.timber || {};

timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $(document.body),

    // Navigation
    $navigation              : $('#AccessibleNav'),
    $mobileSubNavToggle      : $('.mobile-nav__toggle'),

    // Collection Pages
    $changeView              : $('.change-view'),

    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  };
};

timber.init = function () {
  FastClick.attach(document.body);
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.drawersInit();
  timber.mobileNavToggle();

  timber.productImageSwitch();
  timber.responsiveVideos();
  timber.collectionViews();
  timber.collectionFilter();
  timber.loginForms();
  timber.quickView();
};

timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.drawersInit = function () {
  timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
  
};

timber.mobileNavToggle = function () {
  timber.cache.$mobileSubNavToggle.on('click', function() {
    $(this).parent().toggleClass('mobile-nav--expanded');
  });
};

timber.getHash = function () {
  return window.location.hash;
};


timber.quickView = function () {

    $( 'body' ).on( 'click', '#QuickViewAdd', function( e ) {
      setTimeout( function () {
        $.magnificPopup.close();
      });
    });

  $( 'body' ).on( 'click', '.product-quickview__btn', function( e ) {
    var productURL = secure_url + $( this ).attr( 'href' ), data = { view: 'quickview' };
    $( this ).children( '.fa' ).removeClass( 'fa-eye' ).addClass( 'fa-spinner fa-pulse' );
    $.get( productURL, data, function( response ) {
      $.magnificPopup.open({
        items: {
          src: response,
          type: 'inline'
        },
        type: 'inline',

        fixedContentPos: true,
        fixedBgPos: true,

        overflowY: 'auto',

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: 'my-mfp-slide-bottom'
      });

      ajaxCart.init({
        formSelector: '#QuickViewForm',
        cartContainer: '#CartContainer',
        addToCartSelector: '#QuickViewAdd',
        cartCountSelector: '#CartCount',
        cartCostSelector: '#CartCost',
        moneyFormat: null
      });


      $( '.product-quickview__btn .fa' ).removeClass( 'fa-spinner fa-pulse' ).addClass( 'fa-eye' );

      $( '.quick-view__slider' ).not( '.slick-initialized' ).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          fade: true,
          dots: true,
          adaptiveHeight: false,
          infinite: false,
          useTransform: true,
          speed: 400,
          cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)'
      });


      // Load default variant image
      var imageId = $("#QuickViewForm").find(".swatch-element.color input[type='radio']:checked").parent().data("image-id");
      var $newImage = $( '.quick-view__slider' ).find('img[data-image-id="' + imageId + '"]');
      var imageIndex = $newImage.data('slick-index');
      $( '.quick-view__slider' ).slick('slickGoTo', imageIndex);

    });

      // Change variant image
        $( 'body' ).on( 'click', '.product-quickview .swatch-element.color', function( e ) {
          var imageId = $(this).data('image-id');
          var $newImage = $( '.quick-view__slider' ).find('img[data-image-id="' + imageId + '"]');
          var imageIndex = $newImage.data('slick-index');
          $( '.quick-view__slider' ).slick('slickGoTo', imageIndex);
        });


    e.preventDefault();
    e.stopPropagation();

  });


}

timber.ProductSlickSlider = function () {
  var $productImage = $('#ProductPhotoImg'),
      $productImageSlider = $('#ProductThumbs'),
      $productImageFeature = $('#ProductPhoto');

  $productImageFeature.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    dots: true,
    vertical: false,
    adaptiveHeight: true,
    infinite: false,
    useTransform: true,
    speed: 400,
    cssEase: 'cubic-bezier(0.77, 0, 0.18, 1)',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          // arrows: false,
          dots: true,
          fade: false
        }
      }
    ]
  });

  $productImageSlider
  .on('init', function(event, slick) {
    $productImageSlider.find('.slick-slide.slick-current').addClass('is-active');
  })
  .slick({
    slidesToShow: 8,
    slidesToScroll: 5,
    arrows: true,
    fade: false,
    dots: false,
    vertical: false,
    adaptiveHeight: true,
    focusOnSelect: false,
    infinite: false,
    useTransform: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        }
      },
      {
        breakpoint: 767,
        settings: "unslick"
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

  $productImageFeature.on('afterChange', function(event, slick, currentSlide) {
    $productImageSlider.slick('slickGoTo', currentSlide);
    var currrentNavSlideElem = $productImageSlider.find('.slick-slide[data-slick-index="' + currentSlide + '"]');
    $productImageSlider.find('.slick-slide.is-active').removeClass('is-active');
    $(currrentNavSlideElem).addClass('is-active');
  });

  $productImageSlider.on('click', '.slick-slide', function(event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data('slick-index');
    $productImageFeature.slick('slickGoTo', goToSingleSlide);
  });

}


timber.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;

  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $productImageSlider = $('#ProductThumbs'),
      $productImageFeature = $('#ProductPhoto'),
      $addToCart = $('#AddToCart, #QuickViewAdd'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $quantityElements = $('.quantity-selector, label + .js-qty'),
      $addToCartText = $('#AddToCartText, #QuickViewAddText');

  if (variant) {

    // Update variant image, if one is set
    if (variant.featured_image) {
  //    var newImg = variant.featured_image,
 //         el = $productImage[0];
//       Shopify.Image.switchImage(newImg, el, timber.switchImage);

      //var $newImage = $('.product-single__photo[data-image-id="' + newImg.id + '"]');
      //var imageIndex = $newImage.parents('li').data('slick-index');
     // $productImageFeature.slick('slickGoTo', imageIndex);

      // Variant switching
      var thumbIndex = variant.featured_image.position - 1;
      $productImageFeature.slick('slickGoTo', thumbIndex);


//       var variantHash = '#img' + variant.featured_image.id;
//       $('html, body').animate({
//           scrollTop: $(variantHash).offset().top - 70,
//         }, 1000, function () {
//           // Add hash (#) to URL when done scrolling (default click behavior)
//           //window.location.hash = hash;
//       });


    }

    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html("Add to cart");
      $quantityElements.show();
      $("#AddToCart").show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html("Sold Out");
      $quantityElements.hide();
      $("#AddToCart").show();
    }

    

    // Regardless of stock, update the product price
    if (window.productVariantsCount > 1) {
    
    $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
    

    // Also update and show the product's compare price if necessary

    if (variant.compare_at_price > variant.price) {
      
      $comparePrice
      .html("" + ' ' + Shopify.formatMoney(variant.compare_at_price, moneyFormat))
      .show();
      
    } else {
      $comparePrice.hide();
    }
  }


  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $quantityElements.hide();
  }
};

timber.productImageZoom = function () {
  $productImageFeature = $('.product-single__photos');
    $productImageFeature.magnificPopup({
      delegate: 'a',
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      fixedContentPos: true,
      mainClass: 'mfp-no-margins mfp-with-zoom js-featured-image',
      image: {
        verticalFit: true
      },
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0,1]
      },
      zoom: {
        enabled: true,
        duration: 300
      }
    });
  };

timber.productImageSwitch = function () {
  if (timber.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    timber.cache.$thumbImages.on('click', function(evt) {
      timber.cache.$thumbImages.removeClass("active");
      $(this).addClass("active");
      evt.preventDefault();
      var newImage = $(this).attr('href');
      timber.switchImage(newImage, null, timber.cache.$productImage);

      /*
      timber.cache.$thumbImages.trigger('zoom.destroy');
      $('img.zoomImg').remove();
      $('#ProductPhoto').zoom({ url: newImage});
*/

    });
  }
};

timber.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);

  $('#js-featured-image').attr('href', src);
};

timber.responsiveVideos = function () {
  var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
  var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

  $iframeVideo.each(function () {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
  });

  $iframeReset.each(function () {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
  });
};

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.collectionFilter = function () {
  $(".filter-tag-group .tag-group").each(function () {
    $(this).find("ul li a").click(function (event) {
      event.preventDefault();
      var url = $(this).attr('href');
      $.ajax({
        type: 'GET',
        url: url,
        data: {},
        beforeSend: function (xhr) {
          $("#collection-tags__load").show();
        },
        complete: function (data) {
          $('#collection-content').html($("#collection-content", data.responseText).html());
          history.pushState({
            page: url
          }, url, url);
          timber.collectionFilter();
          $("#collection-tags__load").hide();
          $.magnificPopup.close();
        }
      });
    });
  });

  $('#collection-tags__filter-trigger').magnificPopup({
    type: 'inline',
    items: {
      src: '#collection-tags__filter'
    },

    fixedContentPos: true,
    fixedBgPos: true,

    overflowY: 'auto',

    closeBtnInside: true,
    preloader: false,

    midClick: true,
    removalDelay: 300,
    callbacks: {
      beforeOpen: function () {
        // just a hack that adds mfp-anim class to markup
        this.st.mainClass = this.st.el.attr('data-effect');
      },
      open: function () {
        $.magnificPopup.instance.close = function () {
          $.magnificPopup.proto.close.call(this);
          $('#collection-tags__filter').removeClass('mfp-hide');
        }

      }

    },
  });

};

timber.chimpLetter = function () {
  // Selectors
  var $chimpFormBtn = $('.chimp-letter__btn'),
      $chimpForm = $chimpFormBtn.closest('form.chimp-letter__form')

  //Mailchimp on Popup
  $chimpFormBtn.click(function () {
    var $this = $(this),
        $form = $this.closest('form.chimp-letter__form');

    $.ajax({
      type: $form.attr('method'),
      url: $form.attr('action'),
      data: $form.serialize(),
      cache: false,
      dataType: 'json',
      contentType: "application/json; charset=utf-8",
      error: function (err) {
        alert("Could not connect to the registration server. Please try again later.");
      },
      success: function (data) {
        if (data.result != "success") {
          var data = data.msg,
              newData = data.replace('1 -', '').replace('0 -', '');
          $form.find(".response-text").show().removeClass("success").addClass("error").html(newData);
        }
        else if (data.result == "success") {
          var data = data.msg,
            newData = data.replace('1 -', '').replace('0 -', '');
          $form.find(".response-text").show().removeClass("error").addClass("success").html(newData);
        }
      }
    });
  });

  $chimpForm.keypress(function (e) {
    if (e.which == 13) {
      $(this).find('.chimp-letter__btn').trigger("click");
      return false;
    }
  });

};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

/*============================================================================
  Drawer modules
  - Docs http://shopify.github.io/Timber/#drawers
==============================================================================*/
timber.Drawers = (function () {
  var Drawer = function (id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.$nodes = {
      parent: $('body, html'),
      page: $('#PageContainer'),
      moved: $('.is-moved-by-drawer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  };

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to $nodes.page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Notify the drawer is going to open
    timber.cache.$body.trigger('beforeDrawerOpen.timber', this);

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$nodes.moved.addClass('is-transitioning');
    this.$drawer.prepareTransition();

    this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
    this.drawerIsOpen = true;

    // Set focus on drawer
    this.trapFocus(this.$drawer, 'drawer_focus');

    // Run function when draw opens if set
    if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    // Lock scrolling on mobile
    this.$nodes.page.on('touchmove.drawer', function () {
      return false;
    });

    this.$nodes.page.on('click.drawer', $.proxy(function () {
      this.close();
      return false;
    }, this));

    // Notify the drawer has opened
    timber.cache.$body.trigger('afterDrawerOpen.timber', this);
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) { // don't close a closed drawer
      return;
    }

    // Notify the drawer is going to close
    timber.cache.$body.trigger('beforeDrawerClose.timber', this);

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$nodes.moved.prepareTransition({ disableExisting: true });
    this.$drawer.prepareTransition({ disableExisting: true });

    this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

    this.drawerIsOpen = false;

    // Remove focus on drawer
    this.removeTrapFocus(this.$drawer, 'drawer_focus');

    this.$nodes.page.off('.drawer');

    // Notify the drawer is closed now
    timber.cache.$body.trigger('afterDrawerClose.timber', this);
  };

  Drawer.prototype.trapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.attr('tabindex', '-1');

    $container.focus();

    $(document).on(eventName, function (evt) {
      if ($container[0] !== evt.target && !$container.has(evt.target).length) {
        $container.focus();
      }
    });
  };

  Drawer.prototype.removeTrapFocus = function ($container, eventNamespace) {
    var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';

    $container.removeAttr('tabindex');
    $(document).off(eventName);
  };

  return Drawer;
})();

// Initialize Timber's JS on docready
$(timber.init);
timber.chimpLetter();
timber.ProductSlickSlider();
timber.productImageZoom();
